import * as React from 'react';

function TrashOutlineIconComponent(props: any) {
  return (
    <svg
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6668 4V13.3333C12.6668 14.0667 12.0668 14.6667 11.3335 14.6667H4.66683C3.9335 14.6667 3.3335 14.0667 3.3335 13.3333V4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.6665 4H13.3332"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6668 4.00004H5.3335L6.00016 1.33337H10.0002L10.6668 4.00004Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TrashOutlineIconComponent;
